import { DeleteLabelValueDialogBody } from '@tableau/catalog-ui-temp';
import React from 'react';

import { CatalogProviders } from '~src/catalog/CatalogProviders';
import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';
import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';

export type DeleteLabelValueWrapperProps = {
  readonly labelValue: ILabelValueInfo;
};

export function DeleteLabelValueWrapper(props: ReactActionDialogBodyProps<DeleteLabelValueWrapperProps, void>): JSX.Element {
  return (
    <CatalogProviders>
      <DeleteLabelValueDialogBody category={props.labelValue.category} name={props.labelValue.value} />
    </CatalogProviders>
  );
}